import { render, staticRenderFns } from "./job_fair_details_new.vue?vue&type=template&id=1e803972&scoped=true"
import script from "./job_fair_details_new.vue?vue&type=script&lang=js"
export * from "./job_fair_details_new.vue?vue&type=script&lang=js"
import style0 from "./job_fair_details_new.vue?vue&type=style&index=0&id=1e803972&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e803972",
  null
  
)

export default component.exports